import {BlockRendererApi} from '../api/BlockRendererApi';
import {BaseValidatedClass} from '../BaseValidatedClass';
import {ImmutableHtmlNode} from '../modifications/ImmutableNode';

export class BlockRenderer extends BaseValidatedClass {
  api!: BlockRendererApi;

  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS = ['getPreviewInnerHtml'];

  constructor() {
    super(BlockRenderer.REQUIRED_METHODS, BlockRenderer);
  }

  /**
   * @deprecated - use {@link getPreviewInnerHtml} instead
   */

  public getPreviewHtml(_node: ImmutableHtmlNode): string | undefined {
    return undefined;
  };

  /**
   * @description returns custom content to be displayed inside the {@link Block} root TD element
   */
  public getPreviewInnerHtml(_node: ImmutableHtmlNode): string {
    throw new Error('Method getPreviewInnerHtml() must be implemented by the subclass');
  }
}
